<mat-sidenav-container fullscreen hasBackdrop="false" [ngClass]="{'only-desktop': onlyDesktop}">
  <mat-sidenav #sidenav [mode]="isMobile ? 'over' : 'side'" [opened]="!isMobile" [disableClose]="true" [ngClass]="isMobile ? '': 'mat-drawer-desktop'">
    <app-side-menu [sideMenuItems]="sideMenuItems" *ngIf="isMobile"></app-side-menu>
    <app-side-menu-desktop content [sideMenuItems]="sideMenuItems" *ngIf="!isMobile"></app-side-menu-desktop>
  </mat-sidenav>
  <mat-sidenav-content>
    <app-header-bar-desktop content *ngIf="!isMobile"></app-header-bar-desktop>
    <div class="content">
      <ng-content select="[content]"></ng-content>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
